import { render } from "./PortfolioManagement-page.vue?vue&type=template&id=7d524482&scoped=true"
import script from "./PortfolioManagement-page.vue?vue&type=script&lang=js"
export * from "./PortfolioManagement-page.vue?vue&type=script&lang=js"

import "./PortfolioManagement-page.vue?vue&type=style&index=0&id=7d524482&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d524482"]])

export default __exports__